import { render, staticRenderFns } from "./ModalAssigned.vue?vue&type=template&id=60828b24&scoped=true&lang=pug&"
import script from "./ModalAssigned.vue?vue&type=script&lang=js&"
export * from "./ModalAssigned.vue?vue&type=script&lang=js&"
import style0 from "./ModalAssigned.vue?vue&type=style&index=0&id=60828b24&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60828b24",
  null
  
)

export default component.exports